module.exports = __webpack_public_path__ + "mobile/img/noti_icon_p.15592912.svg";